import i18n from "i18n";
import * as yup from "yup";

// Схема валидации профиля пользователя
export const schema = yup.object().shape({
  username: yup
    .string()
    .required(() => i18n.t("message:error.emptyUsername"))
    .min(3, () => i18n.t("message:error.usernameMinLength")),
  full_name: yup
    .string()
    .required(() => i18n.t("message:error.emptyFullName")),
  email: yup
    .string()
    .required(() => i18n.t("message:error.emptyEmail"))
    .email(() => i18n.t("message:error.invalidEmail")),
  phone: yup
    .string()
    .required(() => i18n.t("message:error.emptyPhone"))
    .test('phone-valid', () => i18n.t("message:error.invalidPhone"), (value) => {
      if (!value) return false;
      const digitsOnly = value.replace(/\D/g, '');
      return digitsOnly.length >= 6;
    }),
});

// Схема валидации смены пароля
export const schemaChangePassword = yup.object().shape({
  CurrentPassword: yup
    .string()
    .required(() => i18n.t("message:error.emptyPassword")),
  NewPassword: yup
    .string()
    .required(() => i18n.t("message:error.emptyNewPassword")),
  ConfirmPassword: yup
    .string()
    .required(() => i18n.t("message:error.emptyConfirmPassword"))
    .oneOf([yup.ref('NewPassword')], () => i18n.t("message:error.passwordsDoNotMatch")),
});

// Валидация текстовых полей (username, full_name)
export const validateFieldUserName = async (name: string, value: any) => {
  try {
    const schemas = yup.object().shape({
      [name]: schema.fields[name],
    });
    await schemas.validate({ [name]: value }, { abortEarly: false });
    return { isValid: true, error: "" };
  } catch (validationError) {
    return { isValid: false, error: validationError.errors[0] };
  }
};

// Валидация email
export const validateFieldEmail = async (name: string, value: any) => {
  try {
    const schemas = yup.object().shape({
      [name]: schema.fields[name],
    });
    await schemas.validate({ [name]: value }, { abortEarly: false });
    return { isValid: true, error: "" };
  } catch (validationError) {
    return { isValid: false, error: validationError.errors[0] };
  }
};

// Валидация телефона
export const validateFieldPhone = async (name: string, value: any) => {
  try {
    const schemas = yup.object().shape({
      [name]: schema.fields[name],
    });
    await schemas.validate({ [name]: value }, { abortEarly: false });
    return { isValid: true, error: "" };
  } catch (validationError) {
    return { isValid: false, error: validationError.errors[0] };
  }
};

// Общая валидация профиля
export const validate = async (data: any) => {
  try {
    await schema.validate(data, { abortEarly: false });
    return { isValid: true, errors: {} };
  } catch (validationErrors) {
    let errors: any = {};
    validationErrors.inner.forEach((error: any) => {
      errors[error.path] = error.message;
    });
    return { isValid: false, errors };
  }
};

// Валидация поля пароля
export const validateFieldPassword = async (name: string, value: any, allPasswordData?: any) => {
  try {
    // Для ConfirmPassword проверяем соответствие с NewPassword
    if (name === 'ConfirmPassword' && allPasswordData) {
      await schemaChangePassword.validate(allPasswordData, { abortEarly: false });
      return { isValid: true, error: "" };
    } else {
      // Для CurrentPassword и NewPassword валидируем только само поле
      const schemas = yup.object().shape({
        [name]: schemaChangePassword.fields[name],
      });
      await schemas.validate({ [name]: value }, { abortEarly: false });
      return { isValid: true, error: "" };
    }
  } catch (validationError) {
    return { isValid: false, error: validationError.errors[0] };
  }
};

// Общая валидация смены пароля
export const validatePassword = async (data: any) => {
  try {
    await schemaChangePassword.validate(data, { abortEarly: false });
    return { isValid: true, errors: {} };
  } catch (validationErrors) {
    let errors: any = {};
    validationErrors.inner.forEach((error: any) => {
      errors[error.path] = error.message;
    });
    return { isValid: false, errors };
  }
};